import FieldConfiguration from '@/Models/FieldConfiguration';
import Formula from '@/Services/Formula/Formula';

export default class Variable {
    constructor(type, value, debug = false) {
        this.type = type;
        this.value = value;
        this._debugMode = debug;
    }

    getResult(dataModel) {
        if (this.type === 'number') {
            if (this._debugMode) {
                console.log('Variable of type VALUE:', this.value);
            }

            return this.value;
        }

        if (!(this.value instanceof FieldConfiguration)) {
            let field = storeManager.getFieldByNumber(this.value);

            if (!field) {
                throw new Error('Value must be an existing field number for variables of type FIELD');
            }

            this.value = field;
        }

        if (!dataModel.values.hasOwnProperty(this.value.key)) {
            if (this._debugMode) {
                console.log(`Variable of type FIELD[${this.value.key}]: does not exist in values =`, null);
            }

            return null;
        }

        if (this.value.calculated_by === 'formula') {
            let result = Formula.fromArray(dataModel.getFormula(this.value.key), this._debugMode).getResult(dataModel);

            if (this._debugMode) {
                console.log(`Variable of type FIELD[${this.value.key}][FORMULA]: `, result);
            }

            return result;
        }

        if (this._debugMode) {
            console.log(`Variable of type FIELD[${this.value.key}][${this.value.calculated_by.toUpperCase()}]: `, dataModel.values[this.value.key].value);
        }

        return dataModel.getValue(this.value.key);
    }
}
